export const STORAGE_OPTIONS = {
	S3_PUBLIC_BUCKET: process.env.AWS_S3_PUBLIC_BUCKET ?? 'kadi-public-staging',
	S3_IMAGES_DIR: process.env.AWS_S3_IMAGES_DIR ?? 'images',
	S3_GENERIC_DIR: process.env.AWS_S3_GENERIC_DIR ?? 'misc',
}
